export enum OverviewViewTypeEnum {
  Account = 'account',
  Opportunity = 'oppty'
}
